import { InteractionImportance } from '../types';

export const SOURCE_ANCHOR_ATTRIBUTE = 'data-track-source-anchor';

export const SOURCE_ANCHOR_SEPARATOR = ';';

const MARKED_IMPORTANCE: ReadonlyArray<InteractionImportance> = ['low', 'high'];

export type MarkedImportance = Exclude<InteractionImportance, 'normal'>;

export type SourceAnchor = {
  element: Element;
  anchor: string;
  stableName: string;
  importance: MarkedImportance | null;
};

const toMarkedImportance = (value: string): MarkedImportance | null =>
  MARKED_IMPORTANCE.includes(value as InteractionImportance)
    ? (value as MarkedImportance)
    : null;

export const readSourceAnchor = (element: Element): SourceAnchor | null => {
  const anchored = element.closest(`[${SOURCE_ANCHOR_ATTRIBUTE}]`);
  const value = anchored?.getAttribute(SOURCE_ANCHOR_ATTRIBUTE);
  if (!anchored || !value) {
    return null;
  }
  const [anchor, stableName = '', importance = ''] = value.split(
    SOURCE_ANCHOR_SEPARATOR,
  );
  return {
    element: anchored,
    anchor,
    stableName,
    importance: toMarkedImportance(importance),
  };
};
